<template>
  <b-col sm="12" lg="12">
    <div class="animated fadeIn">
      <b-card ref="cardRef" class="backClass">
        <LoadingCard v-if="loadingData"></LoadingCard>
        <div v-else>
          <h4 style="display:inline-block">All locations</h4>
          <b-form-input
            style="display:inline-block; width:250px;float:right"
            v-model="searchQuery"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>

          <hr />
          <b-row>
            <b-col
              lg="3"
              sm="6"
              v-for="location in filterItems(locations)"
              :key="location.id"
              style="padding: 5px;"
            >
              <a
                class="locationLabels"
                :href="
                  '#/base/city/?loc=' +
                    location.id +
                    '&city=' +
                    location.locaton +
                    '&lat=' +
                    location.lat +
                    '&lng=' +
                    location.lng
                "
                >{{ location.locaton }}</a
              >
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import LoadingCard from "../shared/LoadingCard.vue";

export default {
  name: "ProfileLocations",
  components: { LoadingCard },
  props: ["locationData"],
  data() {
    return {
      searchQuery: "",
      loadingData: true,
      locations: []
    };
  },
  methods: {
    fetchLocations() {
      this.$http.get("api/teleste/profile/alphaLocations.php", {}).then(
        res => {
          this.locations = res.data.records;
          this.loadingData = false;
        },
        err => {
          console.log(err);
          this.loading = false;
        }
      );
    },
    filterItems: function(locations) {
      var app = this;
      return locations.filter(function(location) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return location.locaton.match(regex);
      });
    }
  },
  mounted() {
    this.fetchLocations();
    this.loadingData = false;
  }
};
</script>

<style scoped>
.locationLabels {
  padding: 9px;
}
</style>
